import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactYouTube from "react-youtube";
import Slider from "react-slick";

//
import BGIMG from "../../../assets/images/our-adv-bg.jpg";
import Modal from "../../../components/modal/Modal";
import PlayIcon from "../../../components/play-icon/PlayIcon";
import IconWrapper from "../../../components/icon-wrapper/IconWrapper";

export default function OurAdvantage() {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(true);

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <IconWrapper icon="arrow-right" w={36} h={36} iconW={24} iconH={24} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <IconWrapper icon="arrow-left" w={36} h={36} iconW={24} iconH={24} />
      </div>
    );
  }

  var settings = {
    dots: false,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const opts = {
    height: "500",
    width: "890",
  };

  function handleChangeIsHidden(v) {
    setIsHidden(v);
  }

  return (
    <StyledOurAdvantage>
      <div className="container">
        <div className="ouradv__wrap">
          <h1>{t("homeAdvantagesTitle")}</h1>
          <div className="ouradv__slider">
            <Slider {...settings}>
              <div className="ouradv__item">
                <p>{t("homeAdvantagesLaserCorrection")}</p>
                <div className="ouradv__item__display display-1">
                  <PlayIcon
                    onClick={() => handleChangeIsHidden(false)}
                    color="var(--white)"
                    size="60px"
                  />
                </div>
              </div>
              <div className="ouradv__item">
                <p>{t("homeAdvantagesCataract")}</p>
                <div className="ouradv__item__display display-2">
                  <PlayIcon onClick={() => handleChangeIsHidden(false)} />
                </div>
              </div>
              <div className="ouradv__item">
                <p>{t("homeAdvantagesSurgery")}</p>
                <div className="ouradv__item__display display-3">
                  <PlayIcon onClick={() => handleChangeIsHidden(false)} />
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
      <Modal isHidden={isHidden} onClose={() => handleChangeIsHidden(true)}>
        <ReactYouTube videoId={isHidden ? "" : "AUd8L94Gv6A"} opts={opts} />
      </Modal>
    </StyledOurAdvantage>
  );
}

const StyledOurAdvantage = styled.section`
  padding: 140px 0 240px;
  background-color: var(--dark-blue);

  .ouradv {
    &__wrap {
      position: relative;

      h1 {
        color: var(--white);
        text-align: center;
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: var(--space-title-subtitle);
      }
    }

    &__slider {
      position: absolute;
      width: 100%;

      .slick-arrow {
        background-color: transparent;
        width: auto;
        height: auto;

        &::before {
          display: none;
        }

        &.slick-next {
          right: -48px;
          top: 55%;
        }

        &.slick-prev {
          left: -48px;
          top: 55%;
        }
      }
    }

    &__item {
      p {
        color: var(--extra-light-blue);
        text-align: center;
        font-size: var(--fs-subtitle);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-subtitle);
      }

      &__display {
        margin-top: 40px;
        position: relative;
        width: 100%;
        height: 480px;
        background-attachment: fixed;
        background-size: cover;
        background-position: 50% 35%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &.display-1 {
          background-image: url(${BGIMG});
        }
        &.display-2 {
          background-image: url(${BGIMG});
        }
        &.display-3 {
          background-image: url(${BGIMG});
        }
      }
    }
  }
`;
